import { AssetSvg } from '@/components/foundation/Svg'
import { Poi } from '@common/types/Poi'
import styles from '@/components/ui/Pois/Poi/PoiContentDefault.scss'

export function PoiSchool({ poi }: { poi: Poi }) {
  return (
    <div className={styles.container}>
      <div className={styles.detailsInfo}>
        <AssetSvg className={styles.icon} name={'assets/Address.svg'} />
        <div>
          <p>{poi.properties?.['addr:full']}</p>
          <p>
            {poi.properties?.['addr:postcode']} {poi.properties?.['addr:city']}
          </p>
        </div>
      </div>
    </div>
  )
}
